module.exports = "/_next/static/images/ico-messagerie-blue-9806a6482ad60baa59397cd1bf7a6bc5.svg";